module.exports = __webpack_public_path__ + "img/noPrize-again.16350d43.png";